import React, { useEffect, useState } from "react";
import Input from "../Common/Components/InputField";
import {
  Grid,
  Typography,
  Button,
  Tooltip,
  Box,
  IconButton,
} from "@mui/material";
import Popover from "@mui/material/Popover";
import EditIcon from "@mui/icons-material/Edit";
import CustomSelect from "../Common/Components/Select";
import { useForm } from "react-hook-form";
import TextArea from "../Common/Components/TextArea";
import ActionButton from "../Common/Components/Button";
import service from "../apiSection/service";
import { ShowAlert } from "../Common/Components/Alert";
import Loading from "../Common/Components/Loading";
import ErrorMessage from "../Common/Components/ErrorMessage";
import KeyboardBackspaceOutlinedIcon from "@mui/icons-material/KeyboardBackspaceOutlined";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import {
  getDepartment,
  getPacDetails,
  getTask,
  getModule,
  getSeverity,
  uploadFileImage,
  createTicket,
  updateEmailPhone,
} from "../apiSection/apiUrlConstent";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  maiDiv: {
    backgroundColor: "white",
    padding: "10px",
    borderRadius: "8px",
  },
  subDiv: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
  createTicketLabel: {
    color: "#0FA5D9",
    fontSize: "18px",
    padding: "0px 0px 10px 0px",
  },
  backDashboardLabel: {
    cursor: "pointer",
    color: "#0FA5D9",
    display: "flex",
    alignItems: "center",
    padding: "0px 0px 10px 0px",
  },
  backIcon: {
    marginRight: "4px",
  },
  body: {
    background: "#F5F8FF",
  },
  padding: {
    padding: "10px",
  },
  mainGrid: {
    backgroundColor: "white",
    borderRadius: "8px",
    padding: "10px",
  },
  pacLabel: {
    color: "#707EAE",
    fontSize: "15px",
  },
  labelRequired: {
    color: "red",
  },
  grid1: {
    width: "100%",
    // marginTop: "20px",
    padding: "10px",
  },
  girdSection: {
    backgroundColor: "#F5F8FF",
    borderRadius: "8px",
    padding: "2px",
  },
  gridStyle: {
    padding: "15px",
    backgroundColor: "white",
    borderRadius: "8px",
  },
  flexStyle: {
    display: "inline-flex",
    justifyContent: "center", // Horizontally centers the content
  },
  outlineIcon: {
    fontSize: "20px",
    color: "#707EAE",
  },
  createButton: {
    float: "right",
    marginTop: "10px",
  },
  gridSection1: {
    flex: 1,
    backgroundColor: "white",
    padding: "20px",
    borderRadius: "8px",
  },
  grid2: {
    backgroundColor: "#F5F8FF",
    padding: "20px",
    borderRadius: "8px",
  },
  infoLabelMap: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "10px",
  },
  infoLabel: {
    color: "#707EAE",
    fontSize: "15px",
  },
  infoValue: {
    color: "#000",
    fontSize: "15px",
  },
}));

export default function CreateTicket(props) {
  const {
    register,
    handleSubmit,
    control,
    setValue,
    formState: { errors },
    watch,
    trigger,
    reset,
  } = useForm();
  const classes = useStyles();
  const userData = useSelector((state) => state.auth.user);
  const [loading, setLoading] = useState(false);
  const [pacsData, setPacsData] = useState([]);
  const [departmentData, setDepartmentData] = useState([]);
  const [moduleData, setModuleData] = useState([]);
  const [selectedDepartmentId, setSelectedDepartmentId] = useState(null);
  const [taskData, setTaskData] = useState([]);
  const [severityData, setSeverityData] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [bounce, setBounce] = useState(null);
  const [fileData, setFileData] = useState([]);
  const { t, i18n } = useTranslation("common");
  const [filePostData, setFilePostData] = useState({});
  const [editMobileError, setEditMobileError] = useState("");
  const [editEmailError, setEditEmailError] = useState("");
  
  const handleInputChange = (event) => {
    // Set the searchValue to userData.user_login before any further actions
    // Clear the timeout on every keystroke
    clearTimeout(bounce);
    const newSearchValue = event.target.value;
    const temp_bounce = setTimeout(() => {
      // Update the search value and call the API only after the user stops typing
      setSearchValue((prevData) => ({
        ...prevData,
        searchText: newSearchValue,
      }));
      handlePacDetails({ searchText: newSearchValue });
    }, 2500); // Adjust debounce delay (in ms) as needed
    setBounce(temp_bounce); // Save the timeout reference for clearing later
  };

  const handlePacDetails = (data) => {
    setLoading(true);
    const postData = {
      search_id: data.searchText,
    };
    service
      .create(getPacDetails, postData)
      .then((res) => {
        if (res.status === 200) {
          setPacsData(res.data);
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        setPacsData("");
        ShowAlert({
          icon: "error",
          // text: error.response.data.message,
          text: "PAC ID entered is invalid",
          width: "400px",
        });
      });
  };

  const handleDepartment = () => {
    setLoading(true);
    service
      .get(getDepartment)
      .then((res) => {
        setLoading(false);
        const filteredData = res.data.result.filter(
          (item) => item.department_id !== 5 && item.department_id !== 6
        );
        setDepartmentData(filteredData);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const handleSeverity = () => {
    setLoading(true);
    service
      .get(getSeverity)
      .then((res) => {
        setLoading(false);
        setSeverityData(res.data.result);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const handleModule = (data) => {
    setSelectedDepartmentId(data.id);
    const postData = {
      department_id: data.id,
    };
    setLoading(true);
    service
      .create(getModule, postData)
      .then((res) => {
        setLoading(false);
        setModuleData(res.data.result);
      })
      .catch((error) => {
        setLoading(false);
        ShowAlert({
          icon: "error",
          text: error.response.data.message,
          width: "400px",
        });
      });
  };

  const handleTask = (data) => {
    const postData = {
      module_id: data.id,
      department_id: selectedDepartmentId,
    };
    setLoading(true);
    service
      .create(getTask, postData)
      .then((res) => {
        setLoading(false);
        setTaskData(res.data.result);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const handleUploadFile = (e) => {
    const files = Array.from(e.target.files); // Convert FileList to an array
    const allowedExtensions = ["jpg", "jpeg", "png", "pdf", "docx", "xlsx", "xls", "doc", "zip"];
    const maxSize = 1024 * 1024; // 1MB in bytes (1MB limit)
    let validFiles = [];
    let errorMessages = [];
  
    files.forEach((file) => {
      const fileExtension = file.name.split(".").pop().toLowerCase();
  
      // Validate file extension
      if (!allowedExtensions.includes(fileExtension)) {
        errorMessages.push(`Invalid file type: ${file.name}`);
        e.target.value=null;
        return;
      }
  
      // Validate file size
      if (file.size > maxSize) {
        errorMessages.push(`File size exceeds 1MB limit: ${file.name}`);
        e.target.value=null;
        return;
      }
  
      // Add valid file to the array
      validFiles.push(file);
    });
  
    // Show error messages for invalid files
    if (errorMessages.length > 0) {
      ShowAlert({
        icon: "error",
        text: errorMessages.join("\n"),
        width: "400px",
      });
    }
  
    if (validFiles.length > 0) {
      // Update state with valid files if any
      setFileData(validFiles);
    } else {
      // Clear the state and reset input field if all files are invalid
      setFileData([]);
      e.target.value = null;
    }
  };
  
  function getFileNameAndExtension(fileName) {
    const dotIndex = fileName.lastIndexOf(".");

    return {
      name: dotIndex !== -1 ? fileName.substring(0, dotIndex) : fileName,
      extension:
        dotIndex !== -1 ? fileName.substring(dotIndex + 1).toLowerCase() : "",
    };
  }

  const handleCreateTicket = async (data) => {
    try {
      if (pacsData?.result?.mobile_no == null && pacsData?.result?.email_id == null) {
        ShowAlert({
          icon: "warning",
          text: "Please update your Mobile Number and Email before raising a ticket.",
          width: "400px",
        });
        return;
      } else if (pacsData?.result?.mobile_no == null) {
        ShowAlert({
          icon: "warning",
          text: "Please update your Mobile Number before raising a ticket.",
          width: "400px",
        });
        return;
      } else if (pacsData?.result?.email_id == null) {
        ShowAlert({
          icon: "warning",
          text: "Please update your Email before raising a ticket.",
          width: "400px",
        });
        return;
      } else {
        setLoading(true);
  
        // Log original file details
        console.log("Original File Data:", fileData);
  
        // Fallback: Rename files if necessary
        const modifiedFiles = fileData.map((file, index) => {
          const fileExtension = file.name.split(".").pop();
          const newFileName = `file_${Date.now()}_${index}.${fileExtension}`;
          return new File([file], newFileName, { type: file.type });
        });
  
        const uploadPromises = modifiedFiles.map((file) => {
          const formData = new FormData();
          formData.append("requestid", "23576598");
          formData.append("file", file);
          formData.append("requesttype", "File Uploads");
          formData.append("requestsrc", "ui");
          formData.append("status", "ui");
          return service.uploadFile(uploadFileImage, formData);
        });
  
        const uploadResponses = await Promise.all(uploadPromises);
  
        // Log upload responses
        console.log("Upload Responses:", uploadResponses);
  
        const uploadedFiles = uploadResponses.map((res) => {
          const decodedName = decodeURIComponent(escape(res.data.result.name));
          const normalizedFileName = decodedName.normalize("NFC");
          const { name, extension } = getFileNameAndExtension(normalizedFileName);
          return {
            path: res.data.result.path,
            name: btoa(unescape(encodeURIComponent(name))), // Encode file name in Base64
            extension,
          };
        });
  
        const postData = {
          subject: data.subject,
          departmenttype: data.departmentType,
          module: data.module,
          task: data.task,
          severity: data.severity || 3,
          uploadattachment:
            uploadedFiles.length > 0 ? btoa(JSON.stringify(uploadedFiles)) : "",
          issuedescription: data.description,
          filename:
            uploadedFiles.length > 0
              ? btoa(JSON.stringify(uploadedFiles.map((file) => file.name)))
              : "",
          file_extension:
            uploadedFiles.length > 0
              ? btoa(JSON.stringify(uploadedFiles.map((file) => file.extension)))
              : "",
          dct_id: pacsData?.result?.dct_id || "",
          pac_id: pacsData?.result?.pacs_id || "",
          erp_id: pacsData?.result?.erp_id || "",
          state: pacsData?.result?.state_name || "",
          DCCB: pacsData?.result?.dccb_code || "",
          district: pacsData?.result?.district || "",
        };
        const ticketResponse = await service.create(createTicket, postData);
        if (ticketResponse.status === 200) {
          setLoading(false);
          reset({
            subject: "",
            departmentType: "",
            module: "",
            task: "",
            severity: "",
            uploadImage: "",
            description: "",
          });
          ShowAlert({
            icon: "success",
            html: `Your ticket has been successfully created with the following <strong>Ticket ID: ${ticketResponse.data.ticket_id}</strong>. Thank you for using our services.`,
            width: "400px",
            confirmButtonText: "OK",
            confirmAction: () => props.Redirectpath("/dashboard"),
          });
        }
      }
    
   }catch (error) {
      setLoading(false);
  
      const errorMessage =
        error.response?.data?.message ||
        "An error occurred while processing your request.";
      ShowAlert({
        icon: "error",
        text: errorMessage,
        width: "400px",
      });
  
      setPacsData("");
    }
  
  };
  const handleBack = () => {
    props.Redirectpath("/dashboard");
  };

  useEffect(() => {
    handleDepartment();
    handleSeverity();
  }, []);

  const defaultPacdetails = (data) => {
    setLoading(true);
    const postData = {
      search_id: data.searchText,
    };
    service
      .create(getPacDetails, postData)
      .then((res) => {
        if (res.status === 200) {
          setPacsData(res.data);
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        setPacsData("");
      });
  };

  const handleEditClick = (event) => {
    setValue("editEmail", pacsData?.result?.email_id);
    setAnchorEl(event.currentTarget); // Set the anchor element
  };
  const handleEditMobile = (event) => {
    setValue("editMobile", pacsData?.result?.mobile_no);
    setMobileOPen(event.currentTarget); // Set the anchor element
  };
  useEffect(() => {
    if (userData && userData.user_login) {
      // Call the API with the user_login only when it is available
      defaultPacdetails({ searchText: userData.user_login });
    }
  }, [userData]); // This will run once when userData is updated

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClose = () => {
    setAnchorEl(null); // Reset the anchor element
  };

  const open = Boolean(anchorEl); // Determine if the popover is open
  const id = open ? "simple-popover" : undefined;

  const handleSaveEmail = () => {
    if (
      editEmailError === "" &&
      watch("editEmail") !== null &&
      watch("editEmail") !== ""
    ) {
      // Check if there are no errors
      const postData = {
        email: watch("editEmail"),
        mobile: pacsData?.result?.mobile_no,
        pac_id: pacsData?.result?.pacs_id,
      };

      setLoading(true);
      service
        .create(updateEmailPhone, postData)
        .then((res) => {
          setLoading(false);
          ShowAlert({
            icon: "success",
            text: "Email Updated Successfully",
            width: "400px",
          });
          handlePacDetails({ searchText: pacsData?.result?.pacs_id });
          setAnchorEl(null); // Reset the anchor element
        })
        .catch((error) => {
          setLoading(false);
          ShowAlert({
            icon: "error",
            text: error.response?.data?.message || "Something went wrong",
            width: "400px",
          });
        });
    } else {
      ShowAlert({
        icon: "warning",
        text: "Email Required",
        width: "400px",
      });
    }
  };

  //Closing Mobile Popover
  const [mobileOpen, setMobileOPen] = useState(null);

  const handleCloseMobile = () => {
    setMobileOPen(null);
  };

  const open1 = Boolean(mobileOpen); // Determine if the popover is open
  const id1 = open1 ? "mobile-popover" : undefined;

  const handleSaveMobile = () => {
    if (
      editMobileError === "" &&
      watch("editMobile") !== null &&
      watch("editMobile") !== ""
    ) {
      const postData = {
        email: pacsData?.result?.email_id,
        mobile: watch("editMobile"),
        pac_id: pacsData?.result?.pacs_id,
      };
      setLoading(true);
      service
        .create(updateEmailPhone, postData)
        .then((res) => {
          setLoading(false);
          ShowAlert({
            icon: "success",
            text: "Mobile Number Updated Successfully",
            width: "400px",
          });
          handlePacDetails({ searchText: pacsData?.result?.pacs_id });
          setMobileOPen(null); // Reset the anchor element
        })
        .catch((error) => {
          setLoading(false);
          ShowAlert({
            icon: "error",
            text: error.response.data.message,
            width: "400px",
          });
        });
    } else {
      ShowAlert({
        icon: "warning",
        text: "Mobile Required must be atleast 12 digit  and max 15 digits",
        width: "400px",
      });
    }
  };

  const handleValidation = async (e) => {
    const isValid = await trigger("editEmail"); // Triggers validation for the email field
    if (isValid) {
      setEditEmailError("");
    } else {
      setEditEmailError("Invalid Email!");
    }
  };
  const handleValidationMobile = async (e) => {
    // Get the value of the mobile input field
    const mobile = e.target.value;

    // Check if the mobile number is exactly 10 digits and only contains numbers
    const isValid = /^[0-9]{12,15}$/.test(mobile);

    if (isValid) {
      setEditMobileError(""); // No error if the input is valid
    } else {
      setEditMobileError(
        "Minimun 12 digits and Maximum 15 digits"
      );
    }
  };

  return (
    <div className={classes.maiDiv}>
      <Loading open={loading} />
      <div className={classes.subDiv}>
        <span className={classes.createTicketLabel}>{t("createTicket")}</span>

        <span className={classes.backDashboardLabel} onClick={handleBack}>
          <KeyboardBackspaceOutlinedIcon className={classes.backIcon} />
          {t("backToDashBoard")}
        </span>
      </div>

      <div className={classes.body}>
        {userData && userData?.role_id !== 1 ? (
          <div className={classes.padding}>
            <Grid container alignItems="center" className={classes.mainGrid}>
              <Grid item xs={12} sm={12} lg={2.5} className={classes.pacLabel}>
                {t("enterPacId/dctId/erpId")}
                <span className={classes.labelRequired}>*</span>
              </Grid>
              <Grid item xs={12} sm={5} lg={3} xl={3}>
                <Input
                  name="searchText"
                  type="text"
                  id="searchText"
                  borderRadius="8px"
                  backgroundColor="white"
                  color="#707EAE"
                  width="80%"
                  height="35px"
                  placeholder={t("enterHere")}
                  inputRef={register("searchText", {
                    required: true,
                    onChange: (e) => handleInputChange(e), // Pass the event object directly
                  })}
                  searchIcon={true}
                />
              </Grid>
            </Grid>
          </div>
        ) : (
          ""
        )}
        <Grid container className={classes.grid1}>
          {/* Main Form Section */}
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={6.5}
            xl={6.5}
            className={classes.girdSection}
          >
            <div className={classes.gridStyle}>
              <Grid container spacing={2}>
                {/* Subject Field */}
                <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                  <Grid container alignItems="center">
                    <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                      <Typography variant="body2" color="#707EAE">
                        {t("subject")}{" "}
                        {<span className={classes.labelRequired}>*</span>}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={7} md={7} lg={7} xl={7}>
                      <Input
                        name="subject"
                        type="text"
                        id="subject"
                        height="45px"
                        placeholder={t("provideSujectOfIssue")}
                        InputProps={{
                          maxLength: "100",
                        }}
                        inputRef={register("subject", {
                          required: true,
                          minLength: {
                            value: 5,
                            message: "Minimum length is 5 characters",
                          },
                        })}
                        fullWidth
                      />
                      <div>
                        {errors.subject &&
                          errors.subject.type === "required" && (
                            <ErrorMessage message="Required !!" />
                          )}
                        {errors.subject &&
                          errors.subject.type === "minLength" && (
                            <ErrorMessage message={errors.subject.message} />
                          )}
                      </div>
                    </Grid>
                  </Grid>
                </Grid>

                {/* Department Type Field */}
                <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                  <Grid container alignItems="center">
                    <Grid item xs={12} sm={5} md={5} lg={5} xl={5}>
                      <Typography variant="body2" color="#707EAE">
                        {t("departmentType")}{" "}
                        <span className={classes.labelRequired}>*</span>
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={7} md={7} lg={7} xl={7}>
                      <CustomSelect
                        name="departmentType"
                        control={control}
                        listItems={departmentData}
                        defaultValue=""
                        keyValue="department_id"
                        height="45px"
                        displayValue="department_desc"
                        placeholder={t("select")}
                        width="100%"
                        required={true}
                        handleChange={(e) => {
                          handleModule({ id: e.target.value });
                        }}
                      />
                      <div>
                        {errors.departmentType &&
                          errors.departmentType.type === "required" && (
                            <ErrorMessage message="Required !!" />
                          )}
                      </div>
                    </Grid>
                  </Grid>
                </Grid>

                {/* Module Field */}
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                  sx={{ marginTop: "15px" }}
                >
                  <Grid container alignItems="center">
                    <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                      <Typography variant="body2" color="#707EAE">
                        {t("module")}{" "}
                        <span className={classes.labelRequired}>*</span>
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={7} md={7} lg={7} xl={7}>
                      <CustomSelect
                        name="module"
                        control={control}
                        listItems={moduleData}
                        defaultValue=""
                        displayValue="module_desc"
                        placeholder={t("select")}
                        keyValue="module_id"
                        height="45px"
                        width="100%"
                        required={true}
                        inputRef={register("module")}
                        handleChange={(e) => handleTask({ id: e.target.value })}
                      />
                      <div>
                        {errors.module && errors.module.type === "required" && (
                          <ErrorMessage message="Required !!" />
                        )}
                      </div>
                    </Grid>
                  </Grid>
                </Grid>

                {/* Task Field */}
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                  sx={{ marginTop: "15px" }}
                >
                  <Grid container alignItems="center">
                    <Grid item xs={12} sm={5} md={5} lg={5} xl={5}>
                      <Typography variant="body2" color="#707EAE">
                        {t("task")}{" "}
                        <span className={classes.labelRequired}>*</span>
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={7} md={7} lg={7} xl={7}>
                      <CustomSelect
                        name="task"
                        control={control}
                        listItems={taskData}
                        defaultValue=""
                        displayValue="task_desc"
                        placeholder={t("select")}
                        keyValue="task_id"
                        height="45px"
                        width="100%"
                        required={true}
                        inputRef={register("task")}
                      />
                      <div>
                        {errors.task && errors.task.type === "required" && (
                          <ErrorMessage message="Required !!" />
                        )}
                      </div>
                    </Grid>
                  </Grid>
                </Grid>

                {/* Severity Field */}
                <Grid
                  sx={{ marginTop: "15px" }}
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                >
                  <Grid container alignItems="center">
                    <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                      <Typography variant="body2" color="#707EAE">
                        {t("severity")}
                        {/* <span className={classes.labelRequired}>*</span> */}
                      </Typography>
                    </Grid>
                    <Grid item xs={11} sm={7} md={7} lg={7} xl={7}>
                      <CustomSelect
                        name="severity"
                        control={control}
                        listItems={severityData}
                        defaultValue=""
                        displayValue="severity_desc"
                        keyValue="severity_id"
                        placeholder={t("select")}
                        height="45px"
                        width="100%"
                        // required={true}
                        inputRef={register("severity", {
                          // required: true,
                        })}
                      />
                      <div>
                        {errors.severity &&
                          errors.severity.type === "required" && (
                            <ErrorMessage message="Required !!" />
                          )}
                      </div>
                    </Grid>
                    <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                      <Tooltip
                        title={
                          <>
                            Critical: Severe, often causing complete system
                            failure, data loss, or significant impact on core
                            functionality. (System crash affecting all users.)
                            <br />
                            <br />
                            High: Significant issues that impact key functions,
                            but the system remains usable (e.g., one record has
                            a problem, but others are fine).
                            <br />
                            <br />
                            Low: Low-impact issues, often cosmetic, with no
                            effect on functionality.
                          </>
                        }
                      >
                        <span className={classes.flexStyle}>
                          <HelpOutlineIcon className={classes.outlineIcon} />
                        </span>
                      </Tooltip>
                    </Grid>
                  </Grid>
                </Grid>

                {/* Upload Attachment Field */}
                <Grid
                  sx={{ marginTop: "15px" }}
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                >
                  <Grid container alignItems="center">
                    <Grid item xs={12} sm={5} md={5} lg={5} xl={5}>
                      <Typography variant="body2" color="#707EAE">
                        {t("uploadAttachment")}{" "}
                        {/* <span className={classes.labelRequired}>*</span> */}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={7} md={7} lg={7} xl={7}>
                      <Input
                        type="file"
                        name="uploadImage"
                        id="uploadImage"
                        borderRadius="8px"
                        backgroundColor="white"
                        color="#707EAE"
                        height="45px"
                        width="100%"
                        multiple={true}
                        inputRef={register("uploadImage", {
                          // required: true,
                          onChange: (e) => handleUploadFile(e),
                        })}
                      />
                      <div>
                        {errors.uploadImage &&
                          errors.uploadImage.type === "required" && (
                            <ErrorMessage message="Required !!" />
                          )}
                      </div>
                    </Grid>
                  </Grid>
                </Grid>

                {/* Description Field */}
                <Grid item xs={12}>
                  <TextArea
                    name="description"
                    label={t("issueDescription")}
                    id="description"
                    minRows={5}
                    placeholder={t("enterDescription")}
                    height="50px"
                    width="97%"
                    required={true}
                    maxLength={1000}
                    inputRef={register("description", {
                      required: true,
                      minLength: {
                        value: 20,
                        message: "Minimum length is 20 characters",
                      },
                    })}
                  />
                  <div>
                    {errors.description &&
                      errors.description.type === "required" && (
                        <ErrorMessage message="Required !!" />
                      )}
                    {errors.description &&
                      errors.description.type === "minLength" && (
                        <ErrorMessage message={errors.description.message} />
                      )}
                  </div>
                </Grid>
              </Grid>
            </div>

            <div className={classes.createButton}>
              <ActionButton
                variant="text"
                padding="10px 30px"
                borderRadius="8px"
                backgroundColor="#0FA5D9"
                color="white"
                buttonText={t("create")}
                handleSubmit={handleSubmit(handleCreateTicket)}
              />
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={0.3} xl={0.3}></Grid>
          {/* Additional Information Section */}
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={5.2}
            xl={5.2}
            className={classes.gridSection1}
          >
            <div className={classes.grid2}>
              {[
                {
                  label: `${t("state")}:`,
                  value: pacsData?.result?.state_name || "-",
                },
                { label: `${t("dccb")}:`, value: pacsData?.result?.dccb_code || "-" },
                {
                  label: `${t("district")}:`,
                  value: pacsData?.result?.district || "-",
                },
                {
                  label: `${t("pacName")}:`,
                  value: pacsData?.result?.dccb_name || "-",
                },
                {
                  label:`${t("branchName")}:`,
                  value: pacsData?.result?.branch || "-",
                },
                { label: `${t("mandalTaluka")}:`, value: "-" },
                {
                  label: `${t("pacsRegisteredId")}:`,
                  value: pacsData?.result?.pacs_id || "-",
                },
                { label: `${t("dctId")}:`, value: pacsData?.result?.dct_id || "-" },
                { label: `${t("erpId")}:`, value: pacsData?.result?.erp_id || "-" },
                {
                  label: (
                    <Box display="flex" alignItems="center">
                      {`${t("siteExecutiveMailAddress")}:`}
                      <Typography component="span" sx={{ color: "red", marginRight: "4px" }}>
                        *
                      </Typography>
                    </Box>
                  ),
                  value: (
                    <Box display="flex" alignItems="center">
                      <Typography variant="body2" sx={{ marginRight: "8px" }}>
                        {pacsData?.result?.email_id || "-"}
                      </Typography>
                      {pacsData ? (
                        <IconButton
                          size="small"
                          onClick={handleEditClick} // Replace with your edit handler
                          sx={{ padding: 0 }}
                        >
                          <EditIcon
                            fontSize="small"
                            sx={{ color: "#707EAE", fontSize: "14px" }}
                          />
                        </IconButton>
                      ) : (
                        ""
                      )}
                      <Popover
                        id={id}
                        open={open}
                        anchorEl={anchorEl}
                        onClose={handleClose}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "left",
                        }}
                      >
                        <div
                          style={{
                            padding: "10px",
                            justifyContent: "space-between",
                            alignContent: "center",
                          }}
                        >
                          <Input
                            name="editEmail"
                            type="text"
                            id="editEmail"
                            label="Email"
                            height="45px"
                            placeholder="Enter Here"
                            width="90%"
                            watch={watch}
                            required={true}
                            maxLength={100} // Use this directly if applicable
                            inputRef={register("editEmail", {
                              onChange: (e) => handleValidation(e),
                              // required:'true',
                              pattern: {
                                value:
                                  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                                message: "Enter a valid email address",
                              },
                            })}
                          />
                          {editEmailError && (
                            <div>
                              <ErrorMessage message={editEmailError} />
                            </div>
                          )}
                          <center>
                            <ActionButton
                              variant="text"
                              padding="10px 30px"
                              borderRadius="8px"
                              marginTop="10px"
                              backgroundColor="#0FA5D9"
                              color="white"
                              width="50%"
                              buttonText="Save"
                              handleSubmit={() => {
                                handleSaveEmail();
                              }}
                            />
                          </center>
                        </div>
                      </Popover>
                    </Box>
                  ),
                },
                {
                  label: (
                    <Box display="flex" alignItems="center">
                      {`${t("siteExecutiveMobileNumber")}:`}
                      <Typography component="span" sx={{ color: "red", marginRight: "4px" }}>
                        *
                      </Typography>
                    </Box>
                  ),
                  value: (
                    <Box display="flex" alignItems="center">
                      <Typography variant="body2" sx={{ marginRight: "8px" }}>
                        {pacsData?.result?.mobile_no || "-"}
                      </Typography>
                      {pacsData ? (
                        <IconButton
                          size="small"
                          onClick={handleEditMobile} // Replace with your edit handler
                          sx={{ padding: 0 }}
                        >
                          <EditIcon
                            fontSize="small"
                            sx={{ color: "#707EAE", fontSize: "14px" }}
                          />
                        </IconButton>
                      ) : (
                        ""
                      )}
                      <Popover
                        id={id1}
                        open={open1}
                        anchorEl={mobileOpen}
                        onClose={handleCloseMobile}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "left",
                        }}
                      >
                        <div
                          style={{
                            padding: "10px",
                            justifyContent: "space-between",
                            alignContent: "center",
                          }}
                        >
                          <Input
                            name="editMobile"
                            type="number"
                            id="editMobile"
                            label="Mobile Number"
                            height="45px"
                            placeholder="Enter Here"
                            width="90%"
                            required={true}
                            watch={watch}
                            inputRef={register("editMobile", {
                              required: false,
                              // maxLength: {
                              //   value: 10,
                              //   message: "Length must be 10",
                              // },
                              // minLength: {
                              //   value: 10,
                              //   message: "Length must be 10",
                              // },
                              onChange: (e) => handleValidationMobile(e),
                            })}
                          />
                          {editMobileError && (
                            <div>
                              <ErrorMessage message={editMobileError} />
                            </div>
                          )}
                          <center>
                            <ActionButton
                              variant="text"
                              padding="10px 30px"
                              borderRadius="8px"
                              marginTop="10px"
                              backgroundColor="#0FA5D9"
                              color="white"
                              width="50%"
                              buttonText="Save"
                              handleSubmit={() => handleSaveMobile()}
                            />
                          </center>
                        </div>
                      </Popover>
                    </Box>
                  ),
                },
              ].map((info, index) => (
                <div key={index} className={classes.infoLabelMap}>
                  <Typography variant="body1" className={classes.infoLabel}>
                    {info.label}
                  </Typography>
                  <Typography
                    variant="body1"
                    className={classes.infoValue}
                    style={{
                      maxWidth: info.label === "Pac Name" ? "350px" : "350px", // Increased width for "Pac Name"
                    }}
                  >
                    {info.value}
                  </Typography>
                </div>
              ))}
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}
